import { createDataContext } from "@app/contexts/create-data-context";
import type { IContext } from "@app/contexts/types";

import { actions, IActions } from "./actions";
import { reducer } from "./reducer";
import { contextDefaults } from "./type-defaults";
import type { IState } from "./types";

// ---
// Context definition
// ----------------------------------------------------------------------------
interface IListingCreateContext extends IContext {
  state: IState;
  actions: IActions;
}

const { Provider, Context } = createDataContext(reducer, actions, contextDefaults, "Listing Create Context");

export { Provider, Context };
export type { IListingCreateContext };
